import type {
  HapticImpactStyle,
  HapticNotificationType,
  HapticsAdapter,
} from '../interfaces/haptics.js';

export function createWebHapticsAdapter(): HapticsAdapter {
  return {
    isSupported() {
      return typeof navigator !== 'undefined' && 'vibrate' in navigator;
    },

    impact(style: HapticImpactStyle = 'light') {
      if (!this.isSupported()) return;
      const duration = style === 'heavy' ? 28 : style === 'medium' ? 18 : 10;
      navigator.vibrate(duration);
    },

    notification(type: HapticNotificationType) {
      if (!this.isSupported()) return;
      const pattern =
        type === 'success'
          ? [12, 40, 12]
          : type === 'warning'
            ? [18, 30, 18]
            : [24, 24, 24, 24];
      navigator.vibrate(pattern);
    },
  };
}
